import { IMatch } from "interfaces/interfaces";
import { ServiceApi } from "../utils/utilAmplify";
import { ServiceName } from "../config/amplify";

class HostAPIClass {
  private readonly api: ServiceApi;
  constructor() {
    this.api = new ServiceApi(ServiceName.HostMatches);
  }
  getHostMatches(hostId: string): Promise<IMatch[]> {
    return this.api.get(`host-matches/${hostId}`);
  }
  invite(payload: IMatch) {
    return this.api.post("invite", payload);
  }
  cancelInvite(payload: IMatch) {
    return this.api.post("cancel-invite", payload);
  }
  removeMatch(payload: IMatch) {
    return this.api.post("remove-match", payload);
  }
  removeTenant(payload: IMatch) {
    return this.api.post("remove-tenant", payload);
  }
  updateOfferedDates(payload: IMatch) {
    return this.api.post("update-offered-dates", payload);
  }
}

export const HostAPI = new HostAPIClass();
